import { useTranslation } from "react-i18next";
import useAppSelector from "../../../../../../hooks/redux/base/useAppSelector";
import { FormProvider } from "react-hook-form";
import { toast } from "react-toastify";
import { ApplicationSubtype, BoxSpg, DividerSpg } from "@duosoftbg/nacid-components";
import { Button, Typography } from "@mui/material";
import SuggestionDetailsSection from "./section/SuggestionDetailsSection";
import { createSuggestionDetailsValidationSchema } from "../../../../../../yup/suggestion/suggestionValidationSchemas";
import {
  completeSuggestionStep,
  setStepSuggestionEdited,
} from "../../../../../../store/redux/slice/Forms/suggestionForm";
import useStepSpecific from "../../../../../../hooks/useStepSpecific";
import { baseEndpointPaths } from "../../../../../../services/serviceCalls";
import useFormReset from "../../../../../../hooks/useFormReset";
import { initialSuggestionDetails } from "../../../../../../init/suggestionInitialValues";
import useStepSpecificValidation from "../../../../../../hooks/useStepSpecificValidation";
import { createFormalValidationFromSchema } from "../../../../../../yup/utils/yupUtils";
import PartialFormDataDialog from "../../../common/form/validation/PartialFormDataDialog";
import React from "react";

const SuggestionStepSuggestion = () => {
  const { t } = useTranslation();

  const suggestionForm = useAppSelector((state) => {
    return state.Forms.SuggestionForm;
  });

  const fullSchema = createSuggestionDetailsValidationSchema;
  const formalSchema = createFormalValidationFromSchema(fullSchema);

  const { onSubmit, methods } = useStepSpecific(
    suggestionForm.suggestionDetails,
    suggestionForm.id,
    baseEndpointPaths.suggestion,
    formalSchema,
    setStepSuggestionEdited,
    completeSuggestionStep,
    initialSuggestionDetails,
  );

  const { onSubmitWithValidations, handleCancel, handleAccept, showModal } = useStepSpecificValidation(
    fullSchema,
    formalSchema,
    methods,
    onSubmit,
  );

  useFormReset(ApplicationSubtype.SUGGESTION, suggestionForm.suggestionDetails, methods.reset);

  return (
    <BoxSpg>
      <FormProvider {...methods}>
        <form
          onSubmit={methods.handleSubmit(onSubmitWithValidations, (errors) => {
            toast.error(t("m.validation.errors.present"));
            console.log(errors);
          })}
        >
          <SuggestionDetailsSection />
          <DividerSpg my={4} />
          <BoxSpg>
            <Typography align={"left"}>
              <Button type={"submit"} variant={"contained"}>
                {t("l.btn.saveData")}
              </Button>
            </Typography>
          </BoxSpg>
        </form>
      </FormProvider>
      <PartialFormDataDialog open={showModal} handleCancel={handleCancel} handleAccept={handleAccept} />
    </BoxSpg>
  );
};
export default SuggestionStepSuggestion;
